import { ExpenseSubProduct } from "./expense";

export class SubProduct {
    cat: number;
    class: string;
    expenses: Array<ExpenseSubProduct>;
    id: string;
    ordinal: number;
    price: number;
    priceText: string;
    title: string;
    titleShort: string;
    constructor(data) {
        this.cat = data.cat;
        this.class = data.class;
        if (data.expenses) {
            this.expenses = data.expenses.map((item) => new ExpenseSubProduct(item));
        }
       
        this.id = data.id;
        this.ordinal = data.ordinal;
        this.price = data.price;
        this.priceText = data.priceText;
        this.title = data.title;
        this.titleShort = data.titleShort;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/subproduct/subproduct.ts